// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__3R1a5","Open":"SideDrawer_Open__3FEDM","Close":"SideDrawer_Close__awT1H"};